import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { skipWhile, take } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: '[app-user]',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  @Input() user: any;
  @Input() filialId: '';
  @Input() userType: any = '';
  @Output('onDelete') delete = new EventEmitter();
  @Output('onSeeFilials') seeFilials = new EventEmitter();
  @Output('onSeeInventars') seeInventars = new EventEmitter();
  @Output() onUnassign = new EventEmitter();
  currentUser: any;
  toggleChangePassword = false;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.authService.LoggedinUser.pipe(
      skipWhile((user) => user === null),
      take(1)
    ).subscribe((user) => {
      this.currentUser = user;
    });
  }

  changePasswordHandler(form: NgForm) {
    if (!form.valid) {
      return false;
    }

    let body = {};

    Object.entries(form.form.value).forEach(([key, value], index) => {
      if (value) {
        body[key] = value;
      }
    });

    this.userService.changePassword(this.user.id, body).subscribe(
      (res) => {
        this.toastr.success('Password has been changed.');
        this.toggleChangePassword = false;
      },
      (err) => {}
    );
  }

  onDelete(user) {
    this.delete.emit(user);
  }
}
